"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.StampDataset = void 0;
const interfaces_1 = require("@build-5/interfaces");
const Dataset_1 = require("./Dataset");
class StampDataset extends Dataset_1.DatasetClass {
    constructor() {
        super(...arguments);
        this.stamp = (this.sendRequest(interfaces_1.WEN_FUNC.stamp));
    }
}
exports.StampDataset = StampDataset;
